module.exports = __webpack_public_path__ + "img/product_sk-ii_3@2x.cad7021b.png";